import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { withGenericConfig } from "contexts/generic-config-context";
import { StyledResourcesSubmenuComponent } from "./resources-submenu-component.scss";
import { LEARN_ITEMS, SUPPORT_ITEMS, BUILD_ITEMS } from "./resources-submenu-constants";
const ResourcesSubmenuComponent = ({ translate })=>{
    const renderSection = (titleKey, items)=>/*#__PURE__*/ _jsxs("div", {
            className: "resources-section submenu-stagger-item",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "section-header submenu-stagger-item",
                    children: translate(titleKey)
                }),
                items.map(({ key, url })=>/*#__PURE__*/ _jsx("a", {
                        className: "text-item",
                        href: url,
                        rel: "noreferrer",
                        children: /*#__PURE__*/ _jsx("span", {
                            className: "item-label",
                            children: translate(key)
                        })
                    }, url))
            ]
        });
    return /*#__PURE__*/ _jsxs(StyledResourcesSubmenuComponent, {
        className: "resources-submenu-component",
        children: [
            renderSection("header.tabs.resources.title.learn", LEARN_ITEMS),
            renderSection("header.tabs.resources.title.support", SUPPORT_ITEMS),
            renderSection("header.tabs.resources.title.build", BUILD_ITEMS)
        ]
    });
};
export default withGenericConfig(ResourcesSubmenuComponent);
